import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LayoutKasir from './layoutKasir';
import LayoutProductPercabang from './productpercabang/layoutProductPercabang';
import { Logout, reset } from '../../fitur/AuthSlice';

/**
 * CafeKasirRouter - Router untuk Cafe POS System
 * Routes yang tersedia hanya untuk kasir dengan tipe cabang 'cafe'
 */
const CafeKasirRouter = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(reset());
    dispatch(Logout());
    navigate('/');
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <LayoutKasir
      onNavigate={handleNavigate}
      onLogout={handleLogout}
      hideLayoutMeja={true}
    >
      <LayoutProductPercabang />
    </LayoutKasir>
  );
};

export default CafeKasirRouter;
